import { WIRING_INSTRUCTIONS_SWISS } from '../../lib/_core/constants/wiring-instructions';
import { EnvironmentNames } from '../../lib/_core/constants/environments';

export const environment = {
  fund: {
    primaryColor: 'rgb(168, 28, 7)',
    secondaryColor: 'rgb(243, 226, 223)',
    ternaryColor: 'rgb(168, 28, 7)',
    logo: 'assets/logos/tb.png',
    publicLogo: 'assets/logos/tb-public.png',
    lightDonateNowButtonLink:
      'https://5432341.app.netsuite.com/core/media/media.nl?id=425986&c=5432341&h=1mbtBQFEwVAtBRaoFfeWHwwCsvUzId6x_hwoHh_JVOsLdNyO',
    darkDonateNowButtonLink:
      'https://5432341.app.netsuite.com/core/media/media.nl?id=425985&c=5432341&h=v7eBj6dwbUKmDb1S9y6NJOyGV_WwAxNMQimOf1HlbkAsGVtm',
    lightDonateNowButtonSrc: 'assets/donate-buttons/swiss_light_donate_button.png',
    darkDonateNowButtonSrc: 'assets/donate-buttons/swiss_dark_donate_button.png',
    favicon:
      'https://images.squarespace-cdn.com/content/5ae9d1402714e568d499f07e/1526729411980-7A3HV54PI4EPUGJ4I7D3/logo.png?format=100w&content-type=image%2Fpng',
    wiringInstructions: WIRING_INSTRUCTIONS_SWISS,
    eftInstructions: null,
    stripeKey:
      'pk_live_51HuFiFEHLm9wiVf0Qg54ybgkb03DDPVV1NVJSnGysIUr8rGCccZtLx1IUVtB9MZ2I1eojn320Gst5vF8sbLjJyZj00m6V2tQpV',
    homeLink: 'https://www.trustbridgeglobal.com/',
    contact: 'http://trustbridgeglobal.com/contact',
    blog: 'http://www.trustbridgeglobal.com/blog',
    privacyPolicy: 'https://www.trustbridgeglobal.com/privacy',
    terms: 'https://www.trustbridgeglobal.com/terms',
    mailTo: 'admin@trustbridgeglobal.com',
    name: 'TrustBridge Global Foundation',
    tenantId: 'swiss_prod',
    server: 'https://portal.trustbridgeglobal.com/api',
    url: 'http://portal.trustbridgeglobal.com',
    gsUrl: 'https://givingspace.trustbridgeglobal.com/',
    environmentName: EnvironmentNames.SWISS,
    languages: ['en-swiss'],
    production: false,
    multiCurrency: true,
    redirectSourceUrl: null,
    signatureApiKey: '82dbebd7-6b9f-4d06-ba49-f320cec3bae8',
  },
};
